export default [
  {
    "src": "/images/careersPics/1 Featured.jpg"
  },
  {
    "src": "/images/careersPics/1-Featured.jpg"
  },
  {
    "src": "/images/careersPics/1.1 Featured.jpg"
  },
  {
    "src": "/images/careersPics/1.jpg"
  },
  {
    "src": "/images/careersPics/1a Featured.jpg"
  },
  {
    "src": "/images/careersPics/2.jpeg"
  },
  {
    "src": "/images/careersPics/5.jpg"
  },
  {
    "src": "/images/careersPics/8.jpg"
  },
  {
    "src": "/images/careersPics/Classy-1.jpg"
  },
  {
    "src": "/images/careersPics/DSC_5155.jpg"
  },
  {
    "src": "/images/careersPics/kids-closet-7.jpg"
  },
  {
    "src": "/images/careersPics/murphy-bed-1.jpeg"
  }
]
